import { render, staticRenderFns } from "./PosGroupsList.vue?vue&type=template&id=5e2281d0"
import script from "./PosGroupsList.vue?vue&type=script&lang=js"
export * from "./PosGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports